// src/constants/badges.js

// NEW: import your PNGs
import barterKingIcon from '../assets/barterking-icon.png';
import merchantStarIcon from '../assets/merchantstar-icon.png';
import creatorFlameIcon from '../assets/creatorflame-icon.png';
import guardianIcon from '../assets/guardian-icon.png';

export const BADGES = [
  {
    id: 'BARTER_KING',
    label: 'Barter King',
    emoji: '👑',
    icon: barterKingIcon,
    subtitle: 'Highest Pi circulation',
    maxSupply: 1,
    accent: '#F7C948',
  },
  {
    id: 'MERCHANT_STAR',
    label: 'Merchant Star',
    emoji: '🛍️',
    icon: merchantStarIcon,
    subtitle: 'Top merchants by sales',
    maxSupply: 3,
    accent: '#6EE7B7',
  },
  {
    id: 'CREATOR_FLAME',
    label: 'Creator Flame',
    emoji: '🔥',
    icon: creatorFlameIcon,
    subtitle: 'Top creators by engagement',
    maxSupply: 5,
    accent: '#FB7185',
  },
  {
    id: 'PI_GUARDIAN',
    label: 'Pi Guardian',
    emoji: '🛡️',
    icon: guardianIcon,
    subtitle: 'Most active & consistent users',
    maxSupply: 10,
    accent: '#60A5FA',
  },
  {
    id: 'COUNCIL',
    label: 'Council',
    emoji: '🏛️',
    subtitle: 'Governance leaders',
    maxSupply: 50,
    accent: '#A78BFA',
  },
  {
    id: 'PI_PIONEER',
    label: 'Pi Pioneer',
    emoji: '🚀',
    subtitle: 'Top referrals',
    maxSupply: 10,
    accent: '#34D399',
  },
  {
    id: 'INNOVATOR',
    label: 'Innovator',
    emoji: '💡',
    subtitle: 'Admin-awarded',
    maxSupply: 999,
    accent: '#F59E0B',
  },
];

export const BADGE_DISPLAY = BADGES.reduce((m, b) => {
  m[b.id] = b;
  return m;
}, {});
